module.exports = __webpack_public_path__ + "static/media/ClockWhite.f35624e7.png";